var _style, _g, _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{clip-path:url(#SVGID_00000119091776240296309130000011168029681717132189_);}\n\t.st2{fill:#3B3349;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5713",
    transform: "translate(-307 -628)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 307, 628)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_900-2",
    className: "st0",
    cx: 17,
    cy: 17,
    r: 17
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5712",
    transform: "translate(324.001 643.839)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -9,
    y: -6,
    width: 18,
    height: 14.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062875733282289926480000012836991965793501103_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5711",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000062875733282289926480000012836991965793501103_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22621",
    className: "st2",
    d: "M6.3,8.3H-6.3C-7.8,8.3-9,7.1-9,5.6v-6.7c0-1.5,1.2-2.7,2.7-2.7h1.9 c0.1,0,0.2,0,0.3-0.1l1.2-1.5C-2.7-5.8-2.4-6-2-6h4c0.4,0,0.7,0.2,0.9,0.5L4.1-4c0.1,0.1,0.2,0.1,0.3,0.1h1.9 C7.8-3.8,9-2.6,9-1.1v6.7C9,7.1,7.8,8.3,6.3,8.3 M-6.3-3.3c-1.2,0-2.2,1-2.2,2.2v6.7c0,1.2,1,2.2,2.2,2.2H6.3 c1.2,0,2.2-1,2.2-2.2v-6.7c0-1.2-1-2.2-2.2-2.2H4.4c-0.3,0-0.6-0.1-0.7-0.4L2.4-5.2c0,0,0,0,0,0C2.3-5.3,2.2-5.4,2-5.4h-4 c-0.2,0-0.3,0.1-0.4,0.2c0,0,0,0,0,0l-1.2,1.5c-0.2,0.2-0.4,0.4-0.7,0.4L-6.3-3.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22622",
    className: "st2",
    d: "M0,6.5c-0.1,0-0.2,0-0.4,0c-2.5-0.2-4.4-2.4-4.2-4.9s2.4-4.4,4.9-4.2s4.4,2.4,4.2,4.9 C4.3,4.7,2.4,6.5,0,6.5 M0-2c-2.2,0-3.9,1.8-3.9,4s1.8,3.9,4,3.9S4,4.1,4,1.9C4-0.1,2.4-1.8,0.3-2C0.2-2,0.1-2,0-2"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCam);
export default __webpack_public_path__ + "static/media/icon-cam.697392306bf25bd3b2ea745671853095.svg";
export { ForwardRef as ReactComponent };